'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchActions = batchActions;
exports.enableBatching = enableBatching;
var BATCH = exports.BATCH = 'BATCHING_REDUCER.BATCH';

function batchActions(actions) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BATCH;
  return {
    type: type,
    meta: {
      batch: true
    },
    payload: actions
  };
}

function enableBatching(reduce) {
  return function batchingReducer(state, action) {
    if (action && action.meta && action.meta.batch) {
      return action.payload.reduce(batchingReducer, state);
    }

    return reduce(state, action);
  };
}